<template>
    <b-form
        id="password-reset-form"
        @submit.prevent="updatePassword"
    >
        <h3>Change your password</h3>
        <hr>
        <!-- <alert-success :form="form" message="Password Updated" /> -->
        <b-form-group label-align-md="right" label-cols-md="3">
            <template #label for="password">
                {{ 'New Password' }}
            </template>

            <b-form-input
                v-model="form.password"
                type="password"
                name="password"
                minlength="9"
                :class="{'is-invalid': false}"
            />

            <template #description>
                Minimum length of 9 characters
            </template>
        </b-form-group>

        <b-form-group label-align-md="right" label-cols-md="3">
            <template #label for="password_confirmation">
                {{ 'Confirm Password' }}
            </template>

            <b-form-input
                v-model="form.password_confirmation"
                type="password"
                name="password_confirmation"
                :class="{
                    'is-invalid': false,
                }"
            />
        </b-form-group>

        <b-form-row class="justify-content-center">
            <v-button type="outline-success" :loading="form.busy">
                <fa-icon :icon="['fal','sync']" />
                {{ 'Update' }}
            </v-button>
        </b-form-row>
    </b-form>
</template>

<script>
import PerkinsApi from '@/PerkinsApi';
import alertManager from '~/plugins/alertManager';
import { mapState } from 'vuex';

const initialFormData = {
    password: null,
    password_confirmation: null,
};

export default {
    data: () => ({
        form: {
            password: null,
            password_confirmation: null,
        },
    }),

    computed: {
        ...mapState('auth', {
            userId: (state) => state.user.userId,
        }),
    },

    methods: {
        async updatePassword() {
            try {
                await PerkinsApi.patch(`/settings/password`, this.form);
                this.form = { ...initialFormData };
                alertManager.showSuccess({ message: 'Successfully changed password.' });
            } catch (error) {
                alertManager.showErr(error);
            }
        },
    }
};
</script>
